import React from "react";

export default function TextWithIconFieldComponent({ classes,icon,iconAction, ...rest }) {
    
    return (
        <div className={`mc-icon-field ${ classes || "w-md h-sm" }`}>
            <i className="material-icons" onClick={iconAction} style={{ cursor: 'pointer' ,color:'red'}}>{icon || 'account_circle'}</i>
            
            <input 
                type={"text"}  
                { ...rest } 
            />
       </div>
    )
}